import { cn } from "~/lib/cn";
import { Link } from "@builder.io/qwik-city";
import { component$ } from "@builder.io/qwik";

import { LuChevronRight } from "@qwikest/icons/lucide";
import { LuChevronsRight } from "@qwikest/icons/lucide";

interface BreadcrumbProps {
  class?: string;
  items: { label: string; href: string }[];
  variant?: "chevron" | "chevrons";
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  isBold?: boolean;
  isHeading?: boolean;
  useGrayLinks?: boolean;
}

interface BreadcrumbItem {
  label: string;
  href: string;
}

export const Breadcrumb = component$((props: BreadcrumbProps) => {
  const {
    variant = "chevron",
    size = "sm",
    isBold = true,
    isHeading = false,
    useGrayLinks = true,
  } = props;

  const Separator = variant === "chevrons" ? LuChevronsRight : LuChevronRight;

  const textSizeClass = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl",
  }[size];

  const fontClass = cn(
    textSizeClass,
    isBold && "font-medium",
    isHeading && "font-heading",
  );

  return (
    <nav class={cn("mb-4 flex", props.class)} aria-label="Breadcrumb">
      <ol class="inline-flex items-center gap-2">
        {props.items.map((item: BreadcrumbItem, index: number) => (
          <li
            key={item.href}
            class="inline-flex items-center gap-2 leading-none"
          >
            {index > 0 && (
              <Separator
                class={cn(
                  "mt-0.5",
                  useGrayLinks ? "text-gray-400" : "text-black",
                  size === "sm" && "h-4 w-4",
                  size === "md" && "h-5 w-5",
                  (size === "lg" || size === "xl") && "h-6 w-6",
                  (size === "2xl" || size === "3xl") && "h-7 w-7",
                )}
              />
            )}
            {index === props.items.length - 1 ? (
              <p class={cn("h-full leading-none text-black", fontClass)}>
                {item.label}
              </p>
            ) : (
              <Link
                href={item.href}
                class={cn(
                  "h-full leading-none",
                  useGrayLinks
                    ? "text-gray-800 hover:text-gray-600"
                    : "text-black hover:text-black/80",
                  fontClass,
                )}
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
});
